import React from "react";

/**
 * The "Interface language" / "Native language" / "Country" / "Timezone"
 * fields in Profile Settings were four copy-pasted blocks of near-identical
 * JSX (open/search/select-from-list). This is the shared shape — callers
 * still own their own open/search/selected state, this just renders it and
 * handles clearing the search + closing on select.
 */
export default function SearchableDropdown({
  label,
  isOpen, onToggle, onClose,
  searchTerm, onSearchChange, searchPlaceholder,
  options, selected, onSelect,
  showFlag = true,
  contentClassName = 'language-dropdown-content',
}) {
  const handleSelect = (option) => {
    onSelect(option);
    onClose();
    onSearchChange('');
  };

  return (
    <div className="profile-field">
      <label>{label}</label>
      <div className="language-dropdown">
        <div className="language-selected" onClick={onToggle}>
          <div className="language-info">
            {showFlag && <span className="flag">{selected.flag}</span>}
            <span className="language-name">{selected.name}</span>
          </div>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        {isOpen && (
          <div className={contentClassName}>
            <input
              type="text"
              placeholder={searchPlaceholder}
              className="language-search"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <div className="language-options">
              {options.map(option => (
                <div
                  key={option.value}
                  className="language-option"
                  onClick={() => handleSelect(option)}
                >
                  {showFlag && <span className="flag">{option.flag}</span>}
                  <span className="language-name">{option.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
